'use strict';

var body = document.body || document.documentElement;
body.classList.remove('util-IsTabbing');

var handleFirstTab = function handleFirstTab(e) {
  if (e.keyCode === 9) {
    body.classList.add('util-IsTabbing');

    window.removeEventListener('keydown', handleFirstTab);
    window.addEventListener('mousedown', handleMouseDownOnce);
  }
};

window.addEventListener('keydown', handleFirstTab);

var handleMouseDownOnce = function handleMouseDownOnce() {
  body.classList.remove('util-IsTabbing');

  window.removeEventListener('mousedown', handleMouseDownOnce);
  window.addEventListener('keydown', handleFirstTab);
};

window.addEventListener('mousedown', handleMouseDownOnce);